import React from "react";
import { AlertCircle } from "lucide-react";
import { Card, colors, spacing, typography } from "../../../design-system";

interface ErrorBlockProps {
  title?: string;
  message: string;
}

export default function ErrorBlock({ title, message }: ErrorBlockProps) {
  return (
    <Card
      style={{
        background: colors.dangerSoft,
        border: "1px solid " + colors.danger + "40",
        display: "flex",
        alignItems: "flex-start",
        gap: spacing[3],
        marginBottom: spacing[5],
      }}
    >
      <AlertCircle
        size={20}
        color={colors.danger}
        style={{ flexShrink: 0, marginTop: 2 }}
      />
      <div style={{ flex: 1 }}>
        <div
          style={{
            ...typography.bodyStrong,
            color: colors.dangerText,
            marginBottom: 4,
          }}
        >
          {title || "Something went wrong"}
        </div>
        <div style={{ ...typography.caption, color: colors.dangerText }}>
          {message}
        </div>
      </div>
    </Card>
  );
}